import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.25395 3.90625V12.2838L4.59395 8.62375C4.30145 8.33125 3.82145 8.33125 3.52895 8.62375C3.23645 8.91625 3.23645 9.38875 3.52895 9.68125L8.47145 14.6238C8.76395 14.9163 9.23644 14.9163 9.52894 14.6238L14.4714 9.68125C14.7639 9.38875 14.7639 8.91625 14.4714 8.62375C14.1789 8.33125 13.7064 8.33125 13.4139 8.62375L9.75395 12.2838V3.90625C9.75395 3.49375 9.41645 3.15625 9.00395 3.15625C8.59145 3.15625 8.25395 3.49375 8.25395 3.90625Z",
		fill: "white"
	})
});
export default SvgArrowDown;
